var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "DialogBase",
    {
      attrs: {
        visible: _vm.visible,
        title: "File & Hình ảnh đính kèm",
        size: "lg",
        "show-confirm": false,
        "cancel-text": "Đóng",
        "use-panel": true,
        "panel-title": "Danh sách tệp đính kèm",
        "panel-subtitle": `Đang có ${_vm.previewFiles.length} file/ảnh đính kèm trong nhận xét này`,
        "panel-icon": "el-icon-paperclip",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        cancel: _vm.handleClose,
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loadingAll,
              expression: "loadingAll",
            },
          ],
          staticClass: "evaluation-file-preview",
        },
        [
          _vm.imageFiles.length > 0
            ? _c("div", { staticClass: "evl-preview-section" }, [
                _c("div", { staticClass: "evl-preview-section__title" }, [
                  _c("i", { staticClass: "el-icon-picture" }),
                  _c("span", [
                    _vm._v(
                      "Hình ảnh đính kèm (" +
                        _vm._s(_vm.imageFiles.length) +
                        ")"
                    ),
                  ]),
                  _c("span", { staticClass: "evl-preview-section__hint" }, [
                    _vm._v("· Nhấp vào ảnh để phóng to toàn màn hình"),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "evl-image-grid" },
                  _vm._l(_vm.imageFiles, function (file, idx) {
                    return _c(
                      "div",
                      {
                        key: file.objectKey || idx,
                        staticClass: "evl-image-card",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "evl-image-wrapper",
                            on: {
                              click: function ($event) {
                                return _vm.triggerImageZoom(idx)
                              },
                            },
                          },
                          [
                            _c(
                              "el-image",
                              {
                                ref: `imgPreview_${idx}`,
                                refInFor: true,
                                staticClass: "evl-image-display",
                                attrs: {
                                  src: file.previewUrl || file.downloadUrl,
                                  "preview-src-list": _vm.allImageUrls,
                                  fit: "cover",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "evl-image-slot evl-image-loading",
                                    attrs: { slot: "placeholder" },
                                    slot: "placeholder",
                                  },
                                  [
                                    _c("i", { staticClass: "el-icon-loading" }),
                                    _c("span", [_vm._v("Đang tải ảnh...")]),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "evl-image-slot evl-image-error",
                                    attrs: { slot: "error" },
                                    slot: "error",
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-picture-outline",
                                    }),
                                    _c("span", [_vm._v("Lỗi tải ảnh")]),
                                  ]
                                ),
                              ]
                            ),
                            _c("div", { staticClass: "evl-image-overlay" }, [
                              _c("span", { staticClass: "evl-overlay-badge" }, [
                                _c("i", { staticClass: "el-icon-zoom-in" }),
                                _vm._v(" Phóng to\n              "),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "evl-image-info" }, [
                          _c("div", { staticClass: "evl-image-meta" }, [
                            _c(
                              "span",
                              {
                                staticClass: "evl-image-name",
                                attrs: { title: file.rawName },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(file.displayName) +
                                    "\n              "
                                ),
                              ]
                            ),
                            _c("span", { staticClass: "evl-image-ext-badge" }, [
                              _vm._v(_vm._s(file.extension.toUpperCase())),
                            ]),
                          ]),
                          _c(
                            "div",
                            { staticClass: "evl-image-actions" },
                            [
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: "Phóng to ảnh",
                                    placement: "top",
                                  },
                                },
                                [
                                  _c("el-button", {
                                    attrs: {
                                      type: "primary",
                                      size: "mini",
                                      circle: "",
                                      plain: "",
                                      icon: "el-icon-zoom-in",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.triggerImageZoom(idx)
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: "Tải ảnh về máy",
                                    placement: "top",
                                  },
                                },
                                [
                                  _c("el-button", {
                                    attrs: {
                                      type: "success",
                                      size: "mini",
                                      circle: "",
                                      plain: "",
                                      icon: "el-icon-download",
                                      loading:
                                        _vm.loadingKey === file.objectKey,
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.download(file)
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ])
            : _vm._e(),
          _vm.docFiles.length > 0
            ? _c("div", { staticClass: "evl-preview-section" }, [
                _c("div", { staticClass: "evl-preview-section__title" }, [
                  _c("i", { staticClass: "el-icon-document" }),
                  _c("span", [
                    _vm._v(
                      "Tài liệu đính kèm (" + _vm._s(_vm.docFiles.length) + ")"
                    ),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "evl-doc-grid" },
                  _vm._l(_vm.docFiles, function (file) {
                    return _c(
                      "div",
                      { key: file.objectKey, staticClass: "evl-doc-card" },
                      [
                        _c(
                          "div",
                          {
                            class: [
                              "evl-doc-icon",
                              `evl-doc-icon--${file.fileType}`,
                            ],
                          },
                          [_c("i", { class: _vm.getFileIcon(file) })]
                        ),
                        _c("div", { staticClass: "evl-doc-details" }, [
                          _c(
                            "span",
                            {
                              staticClass: "evl-doc-name",
                              attrs: { title: file.rawName },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(file.displayName) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _c("div", { staticClass: "evl-doc-sub-row" }, [
                            _c("span", { staticClass: "evl-doc-badge" }, [
                              _vm._v(_vm._s(_vm.getFileTypeName(file))),
                            ]),
                            file.extension
                              ? _c("span", { staticClass: "evl-doc-ext" }, [
                                  _vm._v("." + _vm._s(file.extension)),
                                ])
                              : _vm._e(),
                          ]),
                        ]),
                        _c(
                          "div",
                          { staticClass: "evl-doc-actions" },
                          [
                            file.isPdf || file.isOffice
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "primary",
                                      size: "mini",
                                      plain: "",
                                      icon: "el-icon-view",
                                      loading:
                                        _vm.loadingKey === file.objectKey,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.preview(file)
                                      },
                                    },
                                  },
                                  [_vm._v("\n              Xem\n            ")]
                                )
                              : _vm._e(),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "success",
                                  size: "mini",
                                  plain: "",
                                  icon: "el-icon-download",
                                  loading: _vm.loadingKey === file.objectKey,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.download(file)
                                  },
                                },
                              },
                              [_vm._v("\n              Tải về\n            ")]
                            ),
                          ],
                          1
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ])
            : _vm._e(),
          _vm.previewFiles.length === 0 && !_vm.loadingAll
            ? _c("div", { staticClass: "evl-preview-empty" }, [
                _c("div", { staticClass: "evl-empty-icon" }, [
                  _c("i", { staticClass: "el-icon-document" }),
                ]),
                _c("p", { staticClass: "evl-empty-text" }, [
                  _vm._v("Không có file hoặc hình ảnh đính kèm nào."),
                ]),
              ])
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }